<template>
  <el-form
    class="login-form"
    status-icon
    :rules="loginRules"
    ref="loginForm"
    :model="loginForm"
    label-width="0"
  >
    <el-form-item class='form-item' prop="username">
      <el-input
        size="small"
        @keyup.enter.native="handleLogin"
        v-model="loginForm.account"
        auto-complete="off"
        placeholder="请输入用户名"
      >
        <i slot="prefix" class="icon-yonghu"></i>
      </el-input>
    </el-form-item>
    <el-form-item class='form-item' prop="password">
      <el-input
        size="small"
        @keyup.enter.native="handleLogin"
        :type="passwordType"
        v-model="loginForm.password"
        auto-complete="off"
        placeholder="请输入密码"
      >
        <i class="el-icon-view el-input__icon" slot="suffix" @click="showPassword"></i>
        <i slot="prefix" class="icon-mima"></i>
      </el-input>
    </el-form-item>
    <el-form-item class='form-item' prop="code">
      <el-row :span="24">
        <el-col :span="16">
          <el-input
            size="small"
            @keyup.enter.native="handleLogin"
            :maxlength="code.len"
            v-model="loginForm.code"
            auto-complete="off"
            placeholder="请输入验证码"
          >
            <i slot="prefix" class="icon-yanzhengma"></i>
          </el-input>
        </el-col>
        <el-col :span="8">
          <div class="login-code">
            <span
              class="login-code-img"
              @click="refreshCode"
              v-if="code.type == 'text'"
            >{{code.value}}</span>
            <img :src="code.src" class="login-code-img" @click="refreshCode" v-else />
            <!-- <i class="icon-shuaxin login-code-icon" @click="refreshCode"></i> -->
          </div>
        </el-col>
      </el-row>
    </el-form-item>
    <el-checkbox v-model="checked" style="margin-top: 20px">记住账号</el-checkbox>&nbsp;
    <a @click="forgotPassword" style="font-size: 14px; text-align: right;cursor:pointer">忘记密码</a>
    <el-form-item class='form-item'>
      <el-button
        type="primary"
        size="small"
        @click.native.prevent="handleLogin"
        class="login-submit"
        style="margin-right:40px"
      >登录</el-button>
      <el-button
        type="success"
        size="small"
        @click.native.prevent="handleRegister"
        class="login-submit"
      >商户入驻</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { isvalidUsername } from "@/util/validate";
import { mapGetters } from "vuex";
import { getCode, systemLogin } from "@/api/login/login";
import { setToken } from "@/util/auth";
import md5 from "js-md5";

export default {
  name: "userlogin",
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!isvalidUsername(value)) {
        callback(new Error("请输入正确的用户名"));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        account: "",
        password: "",
        code: "",
        sign: "",
        type: "JOINS_AGENT"
      },
      checked: false,
      code: {
        src: "",
        value: "",
        len: 4,
        type: "text"
      },
      loginRules: {
        account: [
          { required: true, trigger: "blur", validator: validateUsername }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, message: "密码长度最少为6位", trigger: "blur" }
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 4, max: 4, message: "验证码长度为4位", trigger: "blur" }
        ]
      },
      passwordType: "password"
    };
  },
  created() {
    this.refreshCode();
  },
  mounted() {},
  computed: {
    ...mapGetters(["tagWel"])
  },
  props: [],
  methods: {
    handleRegister() {
      this.$router.push({
        path: "merchantRegister"
      });
    },
    forgotPassword(){
      this.$router.push({
        name: "忘记密码"
      });
    },
    refreshCode() {
      const sign = md5(Date.parse(new Date()) + "");
      this.loginForm.sign = sign;
      this.code.type = "img";
      getCode(sign)
        .then(response => {
          let img = JSON.parse(response.data).pictureData;
          this.code.src = img;
          console.log(this.code.src)
        })
        .catch(() => {
          this.loading = false;
        });
    },
    showPassword() {
      this.passwordType == ""
        ? (this.passwordType = "password")
        : (this.passwordType = "");
    },
    handleLogin() {
      let _this = this;
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          systemLogin(this.loginForm)
            .then(response => {
              if (response.code == "200") {
                let token = response.data;
                // this.$message({
                //     showClose: true,
                //     message: response.data.message,
                //     type: "success"
                // })
                // console.log(token);
                this.$store.commit("SET_TOKEN", token);
                this.$store.commit("DEL_ALL_TAG");
                this.$store.commit("CLEAR_LOCK");
                setToken(token);
                _this.$router.push({ path: _this.tagWel.value });
                console.log("userID", response);
              } else {
                this.$message({
                  showClose: true,
                  message: response.message,
                  type: "warning"
                });
              }

              // let img = JSON.parse(response.data.data).pictureData;
              // this.code.src = img;
            })
            .catch(error => {
              this.loading = false;
              this.$message({
                showClose: true,
                message: error,
                type: "error"
              });
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.login-submit {
  display: inline-block;
  margin: 40px auto 10px 10px;
  width: 150px;
  height: 48px;
  font-size: 14px;
  text-align: center;
  border-radius: 50px;
  border: 0;
}
.form-item{
  margin: 40px 0 60px 0;
}
</style>
